<template>
    <div>
        <div :class="['installation-container', {offset: !hideNavigation}]">
            <installation-prompt/>
        </div>
        <div :class="['bottom-navigation-container', {'modal-open' : isLoginModalOpen || isMenuModalOpen}, {hidden: hideNavigation}]">
            <div class="grid-x align-middle text-center navigation-grid">
                <a class="cell auto menu-button" :class="{selected: isMenuModalOpen}" @click.prevent="openMenuModal">
                    <i class="menu-icon flex-container align-center-middle" v-html="Icon.MENU"></i>
                    <p class="display-xsmall margin-0">More</p>
                </a>
                <a class="cell auto menu-button" :class="{selected: isFoodPage && !isLoginModalOpen && !isMenuModalOpen}" @click.prevent="closeAndGo('food')">
                    <i class="menu-icon flex-container align-center-middle" v-html="Icon.FOOD"></i>
                    <p class="display-xsmall margin-0">Food</p>
                </a>
                <a v-if="currentUser" class="cell auto menu-button" :class="{selected: $route.name === 'orders' && !isLoginModalOpen && !isMenuModalOpen}" @click.prevent="closeAndGo('orders')">
                    <i class="menu-icon flex-container align-center-middle" v-html="Icon.ORDERS"></i>
                    <p class="display-xsmall margin-0">Orders</p>
                </a>
                <a v-if="currentUser" class="cell auto menu-button" :class="{selected: $route.name === 'account' && !isLoginModalOpen && !isMenuModalOpen}" @click.prevent="closeAndGo('account')">
                    <i class="menu-icon flex-container align-center-middle" v-html="Icon.LOGIN"></i>
                    <p class="display-xsmall margin-0">Account</p>
                </a>
                <a v-if="!currentUser" class="cell auto menu-button" :class="{selected: isLoginModalOpen}" @click.prevent="openLoginModal">
                    <i class="menu-icon flex-container align-center-middle" v-html="Icon.LOGIN"></i>
                    <p class="display-xsmall margin-0">Sign In</p>
                </a>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import { Icon } from '@/front/icons';
import InstallationPrompt from './InstallationPrompt.vue';
import { getModule } from 'vuex-module-decorators';
import User from '@/models/user';
import UserModule from '@/stores/modules/user';
import FoodModule from '@/stores/modules/food';
import { registerGlobalEvent } from '@/utils/global-event';
import { registerScrollCallback, removeScrollCallback } from '@/utils/scroll-event-manager';

@Component({
    components: { InstallationPrompt }
})
export default class MobileNavigation extends Vue
{
    userModule!: UserModule;
    foodModule!: FoodModule;
    prevScrollTop: number = 0;
    hideNavigation: boolean = false;

    created(): void {
        this.userModule = getModule(UserModule, this.$store);
        this.foodModule = getModule(FoodModule, this.$store);
    }

    mounted() {
        registerScrollCallback('bottom-navigation', this.onScroll);
        registerGlobalEvent('triggerNavigationDisplay', () => {
            window.setTimeout(() => this.hideNavigation = false, 100);
        });
    }

    openLoginModal() {
        if (this.foodModule.menuModalOpen) this.foodModule.closeMenuModal();
        this.userModule.openLoginModal();
    }

    openMenuModal() {
        if (this.userModule.loginModalOpen) this.userModule.closeLoginModal();
        this.foodModule.openMenuModal();
    }

    closeModals() {
        if (this.userModule.loginModalOpen) this.userModule.closeLoginModal();
        if (this.foodModule.menuModalOpen) this.foodModule.closeMenuModal();
    }

    onScroll(pageContentContainer: HTMLElement) {
        if (this.$route.name !== 'account') {
            if (pageContentContainer.scrollTop > this.prevScrollTop && pageContentContainer.scrollTop > 20) {
                this.hideNavigation = true;
            }
            if (pageContentContainer.scrollTop <= this.prevScrollTop) {
                this.hideNavigation = false;
            }
            this.prevScrollTop = pageContentContainer.scrollTop;
        }
    }

    closeAndGo(route: string) {
        this.closeModals();
        this.$router.push(route);
    }

    get isLoginModalOpen() {
        return this.userModule.loginModalOpen;
    }

    get isMenuModalOpen() {
        return this.foodModule.menuModalOpen;
    }

    get isFoodPage() {
        if (this.$route.name !== undefined && this.$route.name !== null) {
            return ['food', 'product-page', 'product-type', 'create-product', 'edit-product'].indexOf(this.$route.name) !== -1;
        }
        return false;
    }

    get Icon() {
        return Icon;
    }

    get currentUser(): User | null {
        return this.userModule.currentUser;
    }

    destroyed() {
        removeScrollCallback('bottom-navigation');
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.installation-container {
    position: fixed;
    left: 15px;
    right: 15px;
    bottom: 15px;
    transition: bottom ease 0.3s;
    will-change: bottom;
    z-index: 10;

    &.offset {
        bottom: var(--mobile-menu-prompt-offset);
    }
}

.bottom-navigation-container {
    position: fixed;
    display: block;
    bottom: 0;
    left: 0;
    right: 0;
    height: 75px;
    z-index: 10;
    transition: bottom .3s;
    background: var(--mobile-menu-bg);
    box-shadow: var(--mobile-menu-shadow);
    border-radius: var(--mobile-menu-radius) var(--mobile-menu-radius) 0 0;
    will-change: bottom;

    .navigation-grid {
        height: 100%;
    }

    &.hidden {
        bottom: -100px;
    }

    &.modal-open {
        z-index: 13; // fix to keep the bottom navigation on top of login modal (try to find a better way if possible)
    }

    .menu-button {
        color: var(--mobile-menu-color);

        path {
            fill: var(--mobile-menu-color);
        }

        &.selected {
            color: var(--mobile-menu-selected-color);

            p {
                font-weight: bold;
            }

            path {
                fill: var(--mobile-menu-selected-color);
            }
        }
    }

    .menu-icon {
        height: 30px;
    }
}

</style>

